import Top from "./top/main.es6";
import Bnr from './top/bnr.es6';

const top = new Top();
const bnr = new Bnr();